import { render, staticRenderFns } from "./ProfileHeader.vue?vue&type=template&id=673fbe5e&scoped=true"
import script from "./ProfileHeader.vue?vue&type=script&lang=js"
export * from "./ProfileHeader.vue?vue&type=script&lang=js"
import style0 from "./ProfileHeader.vue?vue&type=style&index=0&id=673fbe5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673fbe5e",
  null
  
)

export default component.exports